import { render, staticRenderFns } from "./TransportInfoFormBlock.vue?vue&type=template&id=1a455130"
import script from "./TransportInfoFormBlock.vue?vue&type=script&lang=js"
export * from "./TransportInfoFormBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports